import React from "react";
import SubAdminNotificationSection from "../../Sections/SubAdminNotificationSection/Content";
const SubAdminNotificationPage = () => {
  return <SubAdminNotificationSection />;
};

export default SubAdminNotificationPage;
